import { ICharacterPhoneSettingsData } from './backend';
import { IVector3 } from './gameplay';

export enum MapPointCategory {
	IMPORTANT = 'important',
	WORK = 'work',
	BANK = 'bank',

	SHOP = 'shop',
	CLOTHES_SHOP = 'clothes_shop',

	HOBBY = 'hobby',
	HOSPITAL = 'hospital',

	TATTOO_SALON = 'tattoo_salon',
	HAIR_SALON = 'hair_salon',

	TUNING_STATION = 'tuning_station',
	GAS_STATION = 'gas_station',

	CAR_SHOWROOM = 'car_showroom',

	BUYERS = 'buyers',
	PAINTING = 'painting',
	VEHICLE_TUNING = 'vehicle_tuning',
}

export enum PhoneApps {
	MAIN = 'main',
	MESSENGER = 'messenger',
	CAMERA = 'camera',
	GPS = 'gps',
	BANK = 'bank',
	SETTINGS = 'settings',
	CONTACTS = 'contacts',
	PHONE = 'phone',
	PHOTOS = 'photos',
	ADS = 'ads',
}

export interface IPhoneNotification {
	app: PhoneApps;
	title: string;
	message: string;
}

export interface IPhoneNotificationsCount {
	app: PhoneApps;
	count: number;
}

export interface IPhoneSettings extends Required<ICharacterPhoneSettingsData> {}

export interface IPhoneGpsLocation {
	id: string;
	category: MapPointCategory;
	label: string;
	position: IVector3;
}
